import { FadeIn } from "react-slide-fade-in";
import * as components from "@/components";

/**
 *
 * @param items
 * @param allowedComponents
 * @returns {JSX.Element}
 * @constructor
 */
export default function Content({ items, additionalComponents, demoMode }) {
  const allowedComponents = {
    ...components,
    ...additionalComponents,
  };

  return (
    <section>
      {items.map(({ component, id, props, skipFade }, k) => (
        <FadeIn
          from="bottom"
          positionOffset={0}
          triggerOffset={0}
          durationInMilliseconds={skipFade ? 0 : 500}
          delayInMilliseconds={skipFade ? 0 : 100}
          key={k}
        >
          {id && <a id={id} />}
          {(() => {
            if (typeof component !== "undefined" && component in allowedComponents) {
              const Component = allowedComponents[component];

              return <Component {...props} />;
            }
          })()}
        </FadeIn>
      ))}
    </section>
  );

}

Content.defaultProps = {
  items: [],
  additionalComponents: {},
  demoMode: false,
};
